import qs from "qs";

export type FacebookParams = {
  app_id: string;
  display: "page";
  redirect_uri: string;
  href: string;
};

interface FacebookButtonProps {
  params: FacebookParams;
  className?: string;
  children: React.ReactNode;
}

const DEFAULT_POPUP_OPTIONS = {
  height: 600,
  width: 750,
  location: "no",
  toolbar: "no",
  status: "no",
  directories: "no",
  menubar: "no",
  scrollbars: "yes",
  resizable: "no",
  centerscreen: "yes",
  chrome: "yes",
};

const popupStyles = Object.entries(DEFAULT_POPUP_OPTIONS)
  .map(([key, value]) => `${key}=${value}`)
  .join(",");

export const FacebookButton = ({
  params,
  className,
  children,
}: FacebookButtonProps) => {
  const handleClick = () => {
    const url = `https://www.facebook.com/dialog/share?${qs.stringify(params)}`;
    window.open(url, "", popupStyles);
  };

  return (
    <button
      type="button"
      aria-label="Facebook"
      onClick={handleClick}
      className={className}
      css={`
        text-align: left;
        color: inherit;
        background-color: transparent;
        border: none;
      `}
    >
      {children}
    </button>
  );
};
